import React from 'react'
import { RectLoader } from '../Loader'
import { Wrapper } from './style'

const ViewMaterialLoader: React.FC = () => {
  return (
    <Wrapper>
      <RectLoader width="96" height="30" />
    </Wrapper>
  )
}

export default ViewMaterialLoader
